import styled from "styled-components";

const Wrapper = styled.div`
    border-bottom : solid thin #e6e6e6;
    &:last-of-type{
        border : none;
    }
    display : flex;
    flex-direction : column;
    margin-left : 16px;
    .item{
        >p{
            font-weight : 400;
        }
        display : flex;
        color : rgb(77, 77, 77);
        gap : 16px;
        padding : 16px 10px 16px 0;
        input{
            background : transparent;
            border : none;
            color : #6c6c6c;
        }
        .spacer{
            flex : 1;
        }
       .clearAlign{
            display: flex;
            align-items: flex-start;
            .clear{
            margin-right:8px;
            }
        }
        svg.open{
            transform : rotateX(180deg)
        }
            .dimension-name-container {
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .go-to-hierarchy-button {
            font-family: 'McKinsey Sans';
            font-size: 14px;
            color : #2251ff;
            background: none;
            border: none;
            cursor: pointer;
            
            &:hover{
                    text-decoration : underline;
            }
        }
            .arrow-icon {
                vertical-align: middle;
            }
    }
    svg.open{
        transform : rotateX(180deg)
    }
    .popup-items{
        display : flex;
        flex-direction : column;
        &.close{
            display : none;
        }
        .popup-item{
            label{
                font-weight : 300;
            }
            .flex.vbn-radio-leaf-row--vehicles-total {
                display: flex;
                align-items: center;
                width: 100%;
                gap: 12px;
                min-height: 44px;
                padding: 8px 0;
                box-sizing: border-box;
            }
            .flex.vbn-radio-leaf-row--vehicles-total .spacer {
                flex-shrink: 0;
                width: 24px;
                min-width: 24px;
            }
            .flex.vbn-radio-leaf-row--vehicles-total .info {
                flex: 1;
                min-width: 0;
                padding: 0;
                cursor: pointer;
                overflow: hidden;
                .attribute-name {
                    color: rgb(77, 77, 77);
                    font-size: 1rem;
                    font-weight: 400;
                    font-family: 'McKinsey Sans';
                    margin: 0;
                    line-height: 1.5;
                }
                .comment {
                    font-size: 12px;
                    color: #6c6c6c;
                    margin: 2px 0 0 0;
                    line-height: 1.3;
                }
            }
            .flex.vbn-radio-leaf-row--vehicles-total .tree-selector-cell {
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-left: auto;
                min-width: 28px;
                label {
                    flex: none;
                    flex-direction: row;
                    justify-content: flex-start;
                    padding: 0;
                    word-break: normal;
                }
            }
        }
        .controls{
            display : flex;
            align-items : center;
            margin-right : 16px;
            gap : 10px;
            .portal-search-vbn {
                flex : 1;
                min-width : 0;
            }
            .show-selected{
                padding : 5px;
                color : #2251ff;
                cursor : pointer;
                text-align : right;
                &:hover{
                    text-decoration : underline;
                }
            }
        }
        .status{
            height: 12px;
            font-size : 14px;
            color : #000;
        }
        .years-range-row{
            display: flex;
            flex-wrap: nowrap;
            gap: 12px;
            margin: 8px 16px 16px 0;
            align-items: flex-end;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }
        .years-range-field{
            display: flex;
            flex-direction: column;
            gap: 6px;
            flex: 1 1 0;
            min-width: 0;
            max-width: calc(50% - 6px);
            box-sizing: border-box;
            label{
                font-size: 16px;
                color: rgb(77, 77, 77);
                font-weight: 500;
                text-align: left;
                align-self: stretch;
                display: block;
                flex: none;
                flex-direction: unset;
                justify-content: unset;
                padding: 0;
                word-break: normal;
            }
        }
        .flex1{
            flex : 1;
            overflow : auto;
        }
        .flex1-years{
            flex: 0 0 auto;
            overflow: visible;
        }
        flex : 1;
        overflow : auto;
        .comment{
            font-size : 14px;
            color : rgb(77, 77, 77);
            padding-bottom : 8px;
            margin-left : 32px; 
            margin-right: 32px;
        }
        .collapsiable-checkbox{
                .parent{
                    display : flex;
                    width : 100%;
                    align-items : center;
                    justify-content : space-between;
                    svg{
                        cursor : pointer;
                        padding : 8px;
                        min-width : 16px;
                        transition : 0.4s;
                        &.open{
                            transform : rotateX(180deg)
                        }
                    }
                }
                .flex {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    gap: 12px;
                    min-height: 44px;
                    padding: 8px 0;
                    box-sizing: border-box;
                }
                .flex .spacer {
                    flex-shrink: 0;
                    width: 24px;
                    min-width: 24px;
                }
                .info {
                    flex: 1;
                    min-width: 0;
                    padding: 0;
                    cursor: pointer;
                    overflow: hidden;
                    .attribute-name {
                        color: rgb(77, 77, 77);
                        font-size: 14px;
                        margin: 0;
                        line-height: 1.5;
                    }
                    .comment {
                        font-size: 12px;
                        color: #6c6c6c;
                        margin: 2px 0 0 0;
                        line-height: 1.3;
                    }
                }
                .tree-selector-cell {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    min-width: 28px;
                }
                .children {
                    padding-left : 15px;
                    box-sizing : border-box;
                    transition : 0.4s;
                    &.close{
                        height : 0;
                        overflow : hidden;
                    }
                    &.hideChildren {
                        display: none;
                    }
                    .spacer {
                        width: 24px;
                        min-width: 24px;
                        flex-shrink: 0;
                    }
                }
            }

            label{
                padding: 5px 0;
                flex : 1;
                color : rgb(77, 77, 77);
                word-break : break-all;
                gap: 10px;
                box-sizing: border-box;
                >div{
                    min-width : 20px;
                }
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
            }
    }
`

export default Wrapper